import { saveAs } from "file-saver";
import sanitize_filename from "sanitize-filename";

export const get_download = {
  methods: {
    get_download: function(fid, extension) {
      this.$http.get(this.$store.getters.api_endpoint + "/" + this.get_prefix() + "file/" + fid + "/" + extension,
                     { responseType: "blob" })
        .then( response => {
          const blob = new Blob([response.data], {
            type: response.data.type
          });

          //レスポンスヘッダからファイル名を取得します
          const contentDisposition = response.headers["content-disposition"];
          // ";"区切り文と、"="区切りキーバリューを解体していく
          var cdData = {};
          for(var cdStr of contentDisposition.split(";")){
            var cdKeyValue = cdStr.trim().split("=");
            if(cdKeyValue.length >= 2){
              cdData[cdKeyValue[0]] = cdKeyValue[1].replace(/^"/, "").replace(/"$/, "");
            }
          }
          var fileName = null;
          if("filename*" in cdData){
            // キーfilename*が優先。こちらはURLデコードする
            fileName = cdData["filename*"].replace("UTF-8''", "");
            // デコードするとスペースが"+"になるのでスペースへ置換します
            fileName = decodeURIComponent(fileName).replace(/\+/g, " ");
          }else if("filename" in cdData){
            // キーfilenameはそのまま
            fileName = cdData["filename"];
          }

          //ダウンロードします
          if(fileName !== null){
            saveAs(blob, sanitize_filename(fileName));
          }
        })
        .catch(error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    }
  }
}
